import React from 'react';
import { Link } from '@components';

export default function About() {
  return (
    <div className="container">
      <div className="wy-content about-page">
        <h2>Who am I?</h2>
        <p>
          I'm a hybrid Designer & Front End Developer, gamer and culinary arts fan.  I've been building Web Applications
          for over 9 years between São Paulo, Brasil and Los Angeles, California. Along those years I've turned myself a
          specialist on connecting design and development areas filling their communication gap.  I contribute to Open
          Source Software projects and Startups, in particular as a core developer for a front-end framework{' '}
          <Link href="http://opensource.locaweb.com.br/locawebstyle/" target="_blank">
            locawebstyle
          </Link>.
        </p>
        <h2>EDUCATION</h2>
        <p>
          <strong>Senac University</strong>
          <br />
          Multimedia Production Technology
          <br />
          Advertisement and marketing
        </p>
        <h2>Achievements</h2>
        <ul>
          <li>
            <span>High-quality front-end development for web sites and applications.</span>
          </li>
          <li>
            <span>Modular, scalable, robust, and reusable code.</span>
          </li>
          <li>
            <span>Performance optimization, progressive enhancement, usability, and accessibility.</span>
          </li>
          <li>
            <span>SEO using semantic HTML.</span>
          </li>
          <li>
            <span>Website planning and architecture.</span>
          </li>
          <li>
            <span>User interface design.</span>
          </li>
          <li>
            <span>Integration of CMS templates.</span>
          </li>
        </ul>
        <h2>Skills</h2>
        <ul>
          <li>Scalable HTML/HAML/Slim/JSX and Sass/Less.</li>
          <li>Working knowledge of Javascript and libraries like React.js, Angular and Vue.js.</li>
          <li>Git, Svn and Mercurial.</li>
          <li>PWA, Offline first, Atomic Design and Design Systems.</li>
          <li>
            Development of interfaces with HTML using Ruby on Rails, Sinatra, Wordpress, CakePHP, Django and others
            frameworks.
          </li>
        </ul>
        <h2>Hobbies</h2>
        <p>Gaming, Photography, Drawing & above all else... Father of two cats 🐈.</p>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ecosystems/About/About.jsx